import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters('common', ['getPageList','getCountry']),
	},
	methods: {
		reset() {
			this.formData = {};
			this.calcList = [];
			this.$refs.formbase.resetValidate();
		},
	},
}
